<template>
    <div id="DoneTaskSettings">
        <div class="info-alert">
            <div class="info-icon">
                <span class="material-icons">info</span>
            </div>
            <div class="info-content">
                <div class="info-title">Görev Kapatma İşlemi</div>
                <div class="info-message">
                    Kapatılacak görevlerin başarılı mı başarısız mı olduğunu ve açıklama girerek kapatıldığını sormak için kullanılır.
                </div>
            </div>
        </div>

        <div class="done-task-card">
            <div class="card-header">
                <div class="card-title">Done Task Modal</div>
            </div>
            <div class="card-content">
                <div class="status-option" @click="toggleStatus">
                    <div class="option-icon">
                        <span class="material-icons">settings</span>
                    </div>
                    <div class="option-content">
                        <div class="option-label">Kapatma Durumu Sorulsun</div>
                        <div class="option-description">
                            Görevi kapatırken kapatma durumunu girebilmek için bu seçeneği aktif et. Aktif olmadığı zaman kart hiçbir soru sormadan direkt kapatılır.
                        </div>
                    </div>
                    <div class="option-switch">
                        <a-switch v-model="switchState" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="loading-spinner">
            <span class="material-icons spin">refresh</span> Kaydediliyor...
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "DoneTaskSettings",
    props: {
        details: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            form: {
                showDoneTaskModal: false,
            },
            switchState: false,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            workflows: (state) => state.tasks.workflows,
        }),
    },
    methods: {
        ...mapActions({
            getWorkFlows: "tasks/getWorkFlows",
            updateWorkflow: "tasks/updateWorkflow",
        }),
        toggleStatus() {
            this.switchState = !this.switchState;
            this.saveChanges();
        },
        saveChanges() {
            if (!this.details || !this.details.workflowId) {
                console.error('Workflow ID bulunamadı, kayıt yapılamıyor.');
                this.$message.error('Workflow bilgisi eksik, ayarlar güncellenemiyor.');
                return;
            }
            
            this.loading = true;
            
            const updatedWorkflow = {
                workflowId: this.details.workflowId,
                params: {
                    showDoneTaskModal: this.switchState
                }
            };
            
            console.log('Güncelleniyor:', updatedWorkflow);
            
            this.updateWorkflow(updatedWorkflow)
                .then(() => {
                    this.$message.success('Görev kapatma ayarları başarıyla güncellendi');
                })
                .catch(error => {
                    console.error('Güncelleme sırasında hata oluştu:', error);
                    this.$message.error('Ayarlar güncellenirken bir hata oluştu');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.loading = true;
        
        if (!this.details || !this.details.workflowId) {
            console.error('Workflow ID bulunamadı');
            this.loading = false;
            return;
        }
        
        console.log('Workflow ID:', this.details.workflowId);
        
        this.getWorkFlows().then(() => {
            const workflow = this.workflows.find((workflow) => workflow._id === this.details.workflowId);
            if (workflow) {
                const showDoneTaskModal = typeof workflow.showDoneTaskModal === 'boolean' ? workflow.showDoneTaskModal : false;
                
                this.form = { 
                    ...workflow,
                    showDoneTaskModal
                };
                
                this.switchState = showDoneTaskModal;
                
                console.log('Workflow bulundu, form dolduruldu:', this.form);
                console.log('Switch durumu:', this.switchState);
            } else {
                console.warn('Workflow bulunamadı, varsayılan değer kullanılıyor');
                this.form = { showDoneTaskModal: false };
                this.switchState = false;
            }
            this.loading = false;
        }).catch(error => {
            console.error('Workflow verileri alınırken hata oluştu:', error);
            this.loading = false;
        });
    },
    watch: {
        'details.workflowId': {
            handler(newVal) {
                if (newVal) {
                    console.log('Workflow ID değişti:', newVal);
                    const workflow = this.workflows.find((wf) => wf._id === newVal);
                    if (workflow) {
                        const showDoneTaskModal = typeof workflow.showDoneTaskModal === 'boolean' ? workflow.showDoneTaskModal : false;
                        
                        this.form = { 
                            ...workflow,
                            showDoneTaskModal
                        };
                        
                        this.switchState = showDoneTaskModal;
                    }
                }
            },
            immediate: true
        }
    },
}
</script>
<style lang="scss" scoped>
#DoneTaskSettings {
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    position: relative;

    .loading-spinner {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        font-size: 16px;
        color: #1890ff;
        font-weight: 500;
        
        .spin {
            margin-right: 8px;
            animation: spin 1s infinite linear;
        }
        
        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    }

    .info-alert {
        display: flex;
        align-items: flex-start;
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 6px;
        padding: 16px;
        margin-bottom: 24px;

        .info-icon {
            margin-right: 12px;
            display: flex;
            align-items: center;
            
            .material-icons {
                color: #1890ff;
                font-size: 22px;
            }
        }

        .info-content {
            flex: 1;

            .info-title {
                font-weight: 600;
                font-size: 16px;
                margin-bottom: 4px;
                color: #333;
            }

            .info-message {
                font-size: 14px;
                color: #555;
                line-height: 1.5;
            }
        }
    }

    .done-task-card {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        overflow: hidden;

        .card-header {
            padding: 16px 20px;
            border-bottom: 1px solid #f0f0f0;
            
            .card-title {
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }
        }

        .card-content {
            padding: 20px;

            .status-option {
                display: flex;
                align-items: center;
                padding: 16px;
                border-radius: 6px;
                background-color: #fafafa;
                transition: all 0.2s ease;
                cursor: pointer;

                &:hover {
                    background-color: #f5f5f5;
                }

                .option-icon {
                    margin-right: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    background-color: rgba(24, 144, 255, 0.1);

                    .material-icons {
                        color: #1890ff;
                        font-size: 20px;
                    }
                }

                .option-content {
                    flex: 1;

                    .option-label {
                        font-weight: 500;
                        font-size: 15px;
                        color: #333;
                        margin-bottom: 4px;
                    }

                    .option-description {
                        font-size: 13px;
                        color: #666;
                        line-height: 1.5;
                    }
                }

                .option-switch {
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
